import { useEffect, useRef } from "react";
import isEqual from "lodash/isEqual";
import { Field } from "formik";

const MultiEntry = ({
  options,
  name,
  values = {},
  handleChange = () => {},
}) => {
  const preSelectedValues = useRef(values);

  useEffect(() => {
    if (values && !isEqual(preSelectedValues.current, values)) {
      preSelectedValues.current = values;
      handleChange(values, name);
    }
  }, [values, name, handleChange]);

  return (
    <div className="form-group">
      {options.map((field) => (
        <label key={field} className="flex items-center">
          <Field
            key={field}
            type="checkbox"
            name={`${name}.${field}`}
            checked={values[field]}
            value={values[field]}
            className={"text-indigo-600 cursor-pointer mt-1 ml-1"}
          />
          <div className="ml-1.5 mt-1">
            <h6 className="text-sm font-normal">{field}</h6>
          </div>
        </label>
      ))}
    </div>
  );
};

export default MultiEntry;
